import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
import Router from 'vue-router';
import router from './router'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');


Vue.use(Vuex);
Vue.use(Router);

export default new Vuex.Store({
    state: {
        profile: {},
        files: [],
        lastClick: '',
        import: [],
        importValues: {}

    },

    mutations: {
        updateFiles: (state, files) => {
            console.log("Here", files)
            if(files === null){
                state.files = [];
            }else{
                state.files = files;
            }

        },

        updateProfile: (state, profile) => {
            state.profile = profile;
        },
        updateLastClick: (state, lastClick) => {
            state.lastClick = lastClick;
        },
        updateImportData: (state, data) => {
            state.import = data;
        },
        updateImportDataValues: (state, data) => {
            state.importValues = data;
        },
    },

    actions: {
        getUserProfile(context){
            console.log(context);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            axios.get('/profile').then((response) => {
                if(response.data.user){
                    this.commit('updateProfile', response.data.user);
                }
            }).catch((e) => {
                console.log('UNAUTHENTICATED');
                console.log(e.response)
                if(e.response.status === 401){
                    localStorage.removeItem('token');
                    router.push({name: 'Login'})
                }


                console.log(e.response);
            });
        },


    },

    getters: {
        profile: (state) => {
            return state.profile
        },
        lastClick: (state) => {
            return state.lastClick
        },



    },


});
